import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  excelMassiveUploadProblems: [],
  excelMassiveUploadError: "",
};

export default function ExcelMassiveUploadReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_EXCEL_MASSIVE_UPLOAD:
      return { ...state, loading: action.payload };
    case actions.EXCEL_MASSIVE_UPLOAD_FAIL:
      return { ...state, excelMassiveUploadError: action.payload };
    case actions.EXCEL_MASSIVE_UPLOAD_PROBLEMS:
      return { ...state, excelMassiveUploadProblems: action.payload };
    default:
      return state;
  }
}
